import React from "react"

const OrganisationNotesContext = React.createContext({})

const { Provider, Consumer } = OrganisationNotesContext

export { Provider, Consumer, OrganisationNotesContext }
